import BaseApi from './BaseApi'

class PluginApi {
  static saveList(dataList, onSuccess){
    return BaseApi.post("lms/plugin", dataList, onSuccess)
  }

  static getByTenant(onSuccess, onError){
    return BaseApi.get('lms/plugin', [], onSuccess, onError)
  }
}

export default PluginApi
